var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "service-autocomplete",
    _vm._b(
      {
        ref: "autocomplete",
        attrs: {
          dense: "",
          value: _vm.value,
          placeholder: _vm.generateMessage("actions.create.properties"),
          url: _vm.url,
          solo: "",
          "cache-items": "",
          "id-field": "node_id",
          "search-attributes-array": ["code", "shortname"],
          "use-entities": ""
        },
        on: {
          input: _vm.handleInputChange,
          newItem: function($event) {
            return _vm.$emit("newItem", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function({ item }) {
              return [
                _vm._v(
                  "\n    " + _vm._s(item.code + " - " + item.shortname) + "\n  "
                )
              ]
            }
          },
          {
            key: "selection",
            fn: function({ selected, item }) {
              return [
                _c(
                  "v-chip",
                  {
                    attrs: { small: "", value: selected, close: "" },
                    on: {
                      "click:close": function($event) {
                        return _vm.$refs.autocomplete.handleInputRemove(item)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(item.code + " - " + item.shortname) +
                        "\n    "
                    )
                  ]
                )
              ]
            }
          }
        ])
      },
      "service-autocomplete",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }